import angular, { ILogService } from 'angular'
import { sortBy } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IGestionEstado, IModelEstadoCv } from 'src/model/candidato-api'
import './panel-estados.scss'

class PanelEstadosComponentCtrl {
  list: IGestionEstado[] = []

  constructor(
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelEstadosComponentCtrl] onInit')

    this.AccesoDatos.Datos_Client.leerEstadosDoc().then(
      (response) => (this.list = sortBy(response.list, (e) => e.st.orden))
    )
  }

  nuevoEstado() {
    this.list.push({ estado: '', st: {} as IModelEstadoCv, mails: [] })
  }
}

angular.module('candidato').component('panelEstados', {
  bindings: {},
  controller: PanelEstadosComponentCtrl,
  template: require('./panel-estados.component.html'),
  // templateUrl: "panel-estados.component.html",
})
